import { render, staticRenderFns } from "./stockAnalytics.vue?vue&type=template&id=161b100d&scoped=true&"
import script from "./stockAnalytics.vue?vue&type=script&lang=js&"
export * from "./stockAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./stockAnalytics.vue?vue&type=style&index=0&id=161b100d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161b100d",
  null
  
)

export default component.exports